import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ParkingTypeModel} from '../_models/parking-type.model';
import {HttpUtilsService, QueryParamsModel, QueryResultsModel} from '../../_base/crud';
import {environment} from '../../../../environments/environment';
import { MadAuthService } from '../../mad-auth/mad-auth.service';
import { SubdomainService } from '../../_base/subdomain.service';



@Injectable()
export class ParkingTypeService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/parking-types`;
    constructor(private http: HttpClient, private authService: MadAuthService, private httpUtils: HttpUtilsService, private subDomainService: SubdomainService) {
    }

    // ParkingTypes
    getAll(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL, {headers: httpHeaders});
    }


    fetch(queryParams: QueryParamsModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

        return this.http.get<QueryResultsModel>(this.API_URL, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    getById(ParkingTypeId: number): Observable<ParkingTypeModel> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<ParkingTypeModel>(this.API_URL + `/${ParkingTypeId}`, {headers: httpHeaders});
    }

    // CREATE =>  POST: add a new ParkingType to the server
    create(_item: ParkingTypeModel): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();

        return this.http.post(this.API_URL, _item, {headers: httpHeaders});
    }

    // UPDATE => PUT: update the ParkingType on the server
    update(ParkingType: ParkingTypeModel): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.put(this.API_URL + `/${ParkingType.id}`, ParkingType, {headers: httpHeaders});
    }

    // DELETE => delete the ParkingType from the server
    delete(ParkingTypeId: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        const url = `${this.API_URL}/${ParkingTypeId}`;
        return this.http.delete(url, {headers: httpHeaders});
    }

    // TRASH (User)
    getTrashed(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash', {headers: httpHeaders});
    }

    flushTrash(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash/flush', {headers: httpHeaders});
    }

    deleteFromTrash(_id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/trash/${_id}`, {headers: httpHeaders});
    }

    // TRASH (Admin)
    getAdminTrashed(): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get(this.API_URL + `/admin/trash`, {headers: httpHeaders});
    }

    // delete from admin trash
    deleteFromAdminTrash(_id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/admin/trash/${_id}`, {headers: httpHeaders});
    }

    // restore from trash
    restoreFromTrash(id: number): Observable<any> {

        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/trash/${id}`, {headers: httpHeaders});
    }


    /*
     * Handle Http operation that failed.
     * Let the app continue.
    *
    * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
